/** Base entity class. */
export abstract class Entity {
  abstract isEqual(other: Entity): boolean;

  protected constructor(readonly entityCode: string) {}
}
